import React, { Fragment } from "react";
import Navbar2 from "../../components/Navbar2";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import { useLanguageChange } from "../../hooks/useLanguageChange";
import MetaTags from "../../components/MetaTags/MetaTags";

const TermsOfServicePageEN = () => {
  useLanguageChange({
    currentLanguage: "en",
    redirectTo: "/es/terminos-y-condiciones",
  });
  const metaTagsProps = {
    title: "Terms of Service | Kesil Digital",
    description:
      "Terms of use for the Kesil Digital application for sending email through your Google account. Responsibilities, data access, and contact.",
    url: "/en/terms-of-service",
  };
  return (
    <Fragment>
      <MetaTags {...metaTagsProps} />
      <Navbar2 alwaysFixed />
      <section className="wpo-contact-pg-section section-padding">
        <div className="container">
          <div className="row">
            <h2>Terms of Service</h2>
            <br />
            <br />
            <p>
              By using this application, you agree to the following terms:
            </p>

            <h5 style={{ marginTop: "10px" }}>1. Service description</h5>
            <p>
              Kesil Digital provides software development and process automation
              services, including sending email on behalf of the user through
              integrations with platforms such as Google and other digital tools.
            </p>

            <h5 style={{ marginTop: "10px" }}>2. Use of the service</h5>
            <p>
              The user agrees to use the service lawfully and responsibly. Use of
              the platform to send spam, illegal content, or any activity that
              infringes third-party rights or applicable regulations is
              prohibited.
            </p>

            <h5 style={{ marginTop: "10px" }}>3. Gmail integration</h5>
            <p>
              If the user authorizes access to their Gmail account, that access
              will be used solely to send email on their behalf, in accordance
              with the configured settings.
            </p>
            <p>
              We do not access, read, store, or analyze the content of the
              user&apos;s email for any purpose other than providing the service.
            </p>
            <p>
              The user may revoke this access at any time from their Google
              account settings.
            </p>

            <h5 style={{ marginTop: "10px" }}>4. User responsibility</h5>
            <p>
              The user is solely responsible for the content of email sent
              through the platform. Kesil Digital is not liable for misuse of the
              service or for consequences arising from such use.
            </p>

            <h5 style={{ marginTop: "10px" }}>
              5. Limitation of liability
            </h5>
            <p>
              Kesil Digital does not guarantee continuous availability of the
              service and will not be liable for interruptions, technical
              failures, data loss, or any damage arising from use or inability to
              use the service.
            </p>

            <h5 style={{ marginTop: "10px" }}>6. Third-party services</h5>
            <p>
              Our services may depend on external platforms such as Google or
              other providers. Kesil Digital is not responsible for failures,
              changes, or interruptions in those services.
            </p>

            <h5 style={{ marginTop: "10px" }}>7. Data protection</h5>
            <p>
              Processing of personal data is governed by our Privacy Policy,
              available on our website.
            </p>

            <h5 style={{ marginTop: "10px" }}>8. Termination of service</h5>
            <p>
              We reserve the right to suspend or cancel access to the service in
              the event of breach of these terms or misuse of the platform.
            </p>

            <h5 style={{ marginTop: "10px" }}>9. Changes</h5>
            <p>
              Kesil Digital may modify these terms at any time. Changes will be
              published on the website and will take effect from publication.
            </p>

            <h5 style={{ marginTop: "10px" }}>10. Contact</h5>
            <p>
              For any inquiries, you can contact us at contacto@kesildigital.com
            </p>
          </div>
        </div>
        <section className="wpo-contact-map-section">
          <div className="wpo-contact-map"></div>
        </section>
      </section>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default TermsOfServicePageEN;
